import { openBlock, createBlock, unref, withCtx, createTextVNode, createElementVNode, createVNode, renderSlot } from "vue";
import _sfc_main$1 from "./control_iterable.vue.js";
import _sfc_main$2 from "./control_dynamic.vue.js";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { deserializeControlValue, serializeControlValue } from "../../lib/control.js";
const _hoisted_1 = { "data-qa": "dtc-control-array-item" };
const __default__ = {
  name: "DtcControlArray"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    function generateItem() {
      return void 0;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        value: __props.value,
        disabled: __props.disabled,
        "generate-item": generateItem,
        "onUpdate:value": _cache[0] || (_cache[0] = (e) => emit(unref(VALUE_UPDATE_EVENT), e))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        prefix: withCtx(() => [..._cache[1] || (_cache[1] = [
          createTextVNode(" [ ", -1)
        ])]),
        item: withCtx(({ item, update }) => [
          createElementVNode("div", _hoisted_1, [
            createVNode(_sfc_main$2, {
              value: unref(serializeControlValue)(item),
              disabled: __props.disabled,
              "onUpdate:value": (e) => update(unref(deserializeControlValue)(e))
            }, null, 8, ["value", "disabled", "onUpdate:value"])
          ])
        ]),
        suffix: withCtx(() => [..._cache[2] || (_cache[2] = [
          createTextVNode(" ] ", -1)
        ])]),
        _: 3
      }, 8, ["value", "disabled"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=control_array.vue.js.map
